// Goal sponsor amounts in kr, the same rules as goal sponsor's
// (goal-sponsor-nest-postgres src/goal-subscription-plan/plan-amount-rules.ts)

/** The least a game is charged; less isn't charged at all. */
export const MIN_GAME_CHARGE = 5;

/** Score types with few scores per game: their plans start at 5 kr. */
const FEW_SCORES_TYPES = ['goal', 'medal', 'holeInOne'];

/**
 * Plans billed in whole kr (all plans made from now on, so a new plan too)
 * take amounts under 1 kr; earlier plans keep whole kr as before.
 */
export const isWholeKrPlan = (plan) => !plan || plan.billingUnitOre === 100;

/** 0.1, 0.25 or 0.5, or a whole amount. */
export const isAllowedAmount = (value) => {
  const ore = Math.round(value * 100);
  return (
    Number.isFinite(value) &&
    Math.abs(value * 100 - ore) < 1e-6 &&
    ([10, 25, 50].includes(ore) || (ore >= 100 && ore % 100 === 0))
  );
};

/** The fewest scores a max per game counts so it's 5 kr at this amount. */
export const minCapMultiplier = (amount) =>
  Math.ceil(Math.round((MIN_GAME_CHARGE / amount) * 100) / 100);

/** The lowest amount per score a whole kr plan of this score type may have. */
export const minPlanAmount = (scoreType) =>
  FEW_SCORES_TYPES.includes(scoreType || 'goal') ? MIN_GAME_CHARGE : 0.1;

/**
 * What a whole kr plan charges for a game: the amount per score times the
 * scores, at most the cap, rounded to whole kr but never over the cap.
 * Under 5 kr nothing is charged.
 */
export const gameCharge = (amount, scores, cap) => {
  const capped = cap > 0;
  const owed = Math.max(0, Math.round(amount * scores * 100) / 100);
  const due = capped ? Math.min(owed, cap) : owed;
  if (due < MIN_GAME_CHARGE) {
    return 0;
  }
  const rounded = Math.round(due);
  return capped && rounded > cap ? Math.floor(cap) : rounded;
};
